import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum TransactionStatusesFormErrorStatesEnum {
    UpdateStatusFailed = ErrorStateScheduleEnum.TransactionStatusesFormErrorStatesStartIndex,
    UpdateStatusToCancelledRejected,
    UpdateStatusUnavailableTrigger
}
